import { connect } from 'react-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectCategoryRelatedLinks } from 'src/redux/selectors';
import { ProductPages } from '../components/ProductPages';
import { selectOrderedProductPageNumbers } from '../modules/selectors';

const mapStateToProps = (state: ReduxApplicationState) => ({
  pageType: state.navigation.pageType,
  pageNumbers: selectOrderedProductPageNumbers(state),
  relatedCategoryLinks: selectCategoryRelatedLinks(state),
});

export const ProductPagesContainer = connect(mapStateToProps, {})(ProductPages);
